import React from "react";
import SubTitle from "../common/SubTitle";
import Report from "../manageData/Reports";
import { Box } from "@mui/material";
import { useNavigate } from "react-router";

export default function Reports({ school = false } = {}) {
  const navigate = useNavigate();
  const orgName = JSON.parse(localStorage.getItem("userState"))?.organization
    ?.name;

  const handleManageData = () => {
    navigate("/reports/managedata");
  };

  return (
    <>
      <SubTitle
        title="Reports"
        path={!school ? `${orgName || "organization"} > Reports` : undefined}
        // track={"Data Management"}
        // onTrackClick={handleManageData}
        type="reportPage"
      />
      <Box
        sx={{
          border: "1px solid #A5DCF3",
          borderRadius: "10px",
          margin: { xs: "0px 20px", md: "0px 40px" },
          boxShadow: "-2px 1px 5px 1px #00000040",
          position: "relative",
        }}
      >
        <Report school={school} />
      </Box>
      <Box sx={{ height: "8vh" }}></Box>
    </>
  );
}
